import { createContext, FC, memo, useState } from 'react'
import { FullMeetingFragment, MeetingStep, MeetingStepStatus, MeetingStepViewId } from '../../../../types'

type MeetingStepCurrentState = {
  viewId: MeetingStepViewId
  status: MeetingStepStatus
}

type Props = { meeting: FullMeetingFragment; steps: MeetingStep[] }

type AppraisalFlowContextType = {
  meeting: FullMeetingFragment
  currentStepState: MeetingStepCurrentState
  meetingTypeSteps: MeetingStep[]
  setCurrentStepState: (value: MeetingStepCurrentState) => void
}

export const AppraisalFlowContext = createContext<AppraisalFlowContextType>({} as AppraisalFlowContextType)

export const AppraisalFlowProvider: FC<Props> = memo(function AppraisalFlowProvider({ children, steps, meeting }) {
  const [currentStepState, setCurrentStepState] = useState<MeetingStepCurrentState>({
    viewId: MeetingStepViewId.Intro,
    status: MeetingStepStatus.Visited,
  })

  return (
    <AppraisalFlowContext.Provider value={{ meeting, currentStepState, setCurrentStepState, meetingTypeSteps: steps }}>
      {children}
    </AppraisalFlowContext.Provider>
  )
})
